import React from 'react';

const Title = ({label}) => {
    return (
        <div style={{marginBottom: 12, width: '100%', background: '#1b2039', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 0'}}>
            <span style={{color: '#fff', fontFamily: 'Montserrat, sans-serif', fontSize: 18}}>{label}</span>
        </div>
    )
}

export default Title;